import { makeAutoObservable } from 'mobx';
import {AuthModel} from "../model/auth-model";
import {HTTP_STATUS_CODE} from "../utils/UHttp";

export class ForgotPasswordViewModel {
    email: string = '';
    emailSent: boolean = false;
    errorMessage: string | null = null;
    isLoading: boolean = false;
    private authModel: AuthModel;

    constructor() {
        makeAutoObservable(this);
        this.authModel = AuthModel.getInstance();
    }

    get getEmail() {
        return this.email
    }
    get getisLoading() {
        return this.isLoading
    }
    get getErrorMessage() {
        return this.errorMessage
    }
    get getEmailSent() {
        return this.emailSent
    }

    setEmail = (email: string) => {
        this.email = email;
    };
    setIsLoading = (isLoading: boolean) => {
        this.isLoading = isLoading;
    };
    setEmailSent = (emailSent: boolean) => {
        this.emailSent = emailSent;
    };
    setErrorMessage = (message: string | null) => {
        this.errorMessage = message;
    };

    handleForgotPassword = async (e: any) => {
        e.preventDefault()
        this.setIsLoading(true)
        try {
            const result = await this.authModel.handleForgotPassword(this.email)
            if(result.status === HTTP_STATUS_CODE.OK) {
                this.setEmailSent(true);
            }
            this.setErrorMessage(result.message)

        } catch (error: any) {
            console.error( "ForgotPasswordViewModel.handleForgotPassword",error.response.data.messagee)
        } finally {
            this.setIsLoading(false)
        }
    }
}

const forgotPasswordViewModel = new ForgotPasswordViewModel();

export const useForgotPasswordViewModel = () => {
    return forgotPasswordViewModel
}
